"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentEditorLink = exports.ContentEditorControlButton = exports.ContentEditorHeader = exports.Header = exports.ContentEditorSubmit = exports.ContentEditorControls = void 0;
var react_1 = __importDefault(require("react"));
require("draft-js/dist/Draft.css");
var Dropdown_1 = __importDefault(require("../Dropdown"));
var Underline_1 = __importDefault(require("../../icons/Underline"));
var Titles_1 = __importDefault(require("../../icons/Titles"));
var Link_1 = __importDefault(require("../../icons/Link"));
var Bold_1 = __importDefault(require("../../icons/Bold"));
var Italic_1 = __importDefault(require("../../icons/Italic"));
var Strikethrough_1 = __importDefault(require("../../icons/Strikethrough"));
var UList_1 = __importDefault(require("../../icons/UList"));
var OList_1 = __importDefault(require("../../icons/OList"));
var hooks_1 = require("./hooks");
var styles_1 = require("./styles");
var TITLES_BLOCK_TYPES = [
    { label: react_1.default.createElement("b", { style: { fontSize: 17 } }, "T\u00EDtulo"), style: "header-two" },
    { label: react_1.default.createElement("b", { style: { fontSize: 12 } }, "Subt\u00EDtulo"), style: "header-one" },
];
var BLOCK_TYPES = [
    { label: react_1.default.createElement(UList_1.default, null), style: "unordered-list-item" },
    { label: react_1.default.createElement(OList_1.default, null), style: "ordered-list-item" },
];
var INLINE_STYLES = [
    { label: react_1.default.createElement(Bold_1.default, null), style: "BOLD" },
    {
        label: react_1.default.createElement(Underline_1.default, { height: "17px", style: { marginBottom: -2 } }),
        style: "UNDERLINE",
    },
    { label: react_1.default.createElement(Italic_1.default, null), style: "ITALIC" },
    { label: react_1.default.createElement(Strikethrough_1.default, null), style: "STRIKETHROUGH" },
];
function ContentEditorControls(_a) {
    var style = _a.style, className = _a.className;
    var _b = (0, hooks_1.useContentEditor)(), editorState = _b.editorState, onToggleBlockType = _b.onToggleBlockType, onToggleInlineStyle = _b.onToggleInlineStyle, onToggleLinkStyle = _b.onToggleLinkStyle;
    var selection = editorState.getSelection();
    var currentBlockType = editorState
        .getCurrentContent()
        .getBlockForKey(selection.getStartKey())
        .getType();
    var currentInlineStyle = editorState.getCurrentInlineStyle();
    return (react_1.default.createElement(styles_1.ControlsContainer, { className: className, style: style },
        react_1.default.createElement(Dropdown_1.default, null,
            react_1.default.createElement(Dropdown_1.default.ToggleButton, { style: { marginRight: 16 } },
                react_1.default.createElement(Titles_1.default, null)),
            react_1.default.createElement(Dropdown_1.default.Menu, { style: { zIndex: 9999, minWidth: 132 } }, TITLES_BLOCK_TYPES.map(function (type, index) { return (react_1.default.createElement(Dropdown_1.default.Item, { default: true, style: { padding: "6px 20px" }, key: "content-editor-control-".concat(index) },
                react_1.default.createElement(ContentEditorControlButton, { active: type.style === currentBlockType, label: type.label, onToggle: onToggleBlockType, style: type.style }))); }))),
        INLINE_STYLES.map(function (type, index) { return (react_1.default.createElement(ContentEditorControlButton, { key: "content-editor-control-".concat(index), active: currentInlineStyle.has(type.style), label: type.label, onToggle: onToggleInlineStyle, style: type.style })); }),
        BLOCK_TYPES.map(function (type, index) { return (react_1.default.createElement(ContentEditorControlButton, { key: "content-editor-control-".concat(index), active: type.style === currentBlockType, label: type.label, onToggle: onToggleBlockType, style: type.style })); }),
        react_1.default.createElement(styles_1.UnstyledButton, { onClick: onToggleLinkStyle },
            react_1.default.createElement(Link_1.default, { style: { marginBottom: -2 } }))));
}
exports.ContentEditorControls = ContentEditorControls;
function ContentEditorSubmit(_a) {
    var children = _a.children;
    var contextProps = (0, hooks_1.useContentEditor)();
    return react_1.default.createElement(react_1.default.Fragment, null, children(contextProps));
}
exports.ContentEditorSubmit = ContentEditorSubmit;
function Header(_a) {
    var children = _a.children, style = _a.style, className = _a.className;
    return (react_1.default.createElement(styles_1.HeaderContainer, { style: style, className: className }, children));
}
exports.Header = Header;
function ContentEditorHeader(_a) {
    var children = _a.children, style = _a.style, className = _a.className;
    return (react_1.default.createElement(styles_1.HeaderContainer, { style: style, className: className }, children));
}
exports.ContentEditorHeader = ContentEditorHeader;
function ContentEditorControlButton(props) {
    return (react_1.default.createElement(styles_1.ControlButtonContainer, { onMouseDown: function (event) {
            event.stopPropagation();
            event.preventDefault();
            props.onToggle(props.style);
        }, active: props.active }, props.label));
}
exports.ContentEditorControlButton = ContentEditorControlButton;
function ContentEditorLink(props) {
    var contentState = props.contentState, entityKey = props.entityKey;
    var url = contentState.getEntity(entityKey).getData().url;
    return (react_1.default.createElement("a", { className: "link", href: url, rel: "noopener noreferrer", target: "_blank", "aria-label": url }, props.children));
}
exports.ContentEditorLink = ContentEditorLink;
//# sourceMappingURL=components.js.map